module.exports = __webpack_public_path__ + "images/776924f46d32bb3225526fa1b295c393.svg";